var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('Navbar',{attrs:{"loginActive":true,"showLinks":true,"showAdminLink":_vm.isAdmin},on:{"logout":_vm.logout}}),_c('br'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }